import { RoamPointT } from './RoamPointT';
import { RoofSlapT } from './RoofSlapT';
import { MonitorColorRegionT } from './monitor-object/MonitorRegionT';

export const ModelsInArchiBase = {
	'RoofSlapT': RoofSlapT,
	"MonitorColorRegionT": MonitorColorRegionT,
	'RoamPointT': RoamPointT,
};
